import React, { useEffect, useState } from 'react';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { ThemeProvider, useThemeMode } from '@rneui/themed';
import Toast from 'react-native-toast-message';
import { createTheme, useColorScheme, } from '@annunciate/ui';
import { Nav } from '@annunciate/web/dist/components/Nav';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useBodyStyles } from '../hooks';
import { RootView } from './RootView';
const ThemedAppInner = ({ children }) => {
    useBodyStyles();
    const { setMode } = useThemeMode();
    const color = useColorScheme();
    useEffect(() => setMode(color), [color]);
    return (React.createElement("div", { id: "detail" }, children));
};
export const ThemedApp = ({ children, theme: initialTheme = {} }) => {
    const [theme] = useState(createTheme(initialTheme));
    const scheme = useColorScheme();
    const [renderToast, setRenderToast] = useState(false);
    useEffect(() => {
        if (scheme && scheme !== theme.mode) {
            theme.mode = scheme;
        }
    }, [
        theme.mode,
        scheme,
    ]);
    useEffect(() => setRenderToast(true));
    useBodyStyles();
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(ThemedAppInner, null,
            React.createElement(GestureHandlerRootView, { style: { flex: 1 } },
                React.createElement(Nav, null),
                React.createElement(RootView, null, children),
                renderToast && React.createElement(Toast, null)))));
};
//# sourceMappingURL=ThemedApp.js.map